<template>
	<div class="body-container" id="h-box">
		<Header :headerMini="headerMini" v-if="!headerMini"></Header>
		<div id="maincontent" class="main location-country" rel="main">
			<div class="page-header-options">
				<div class="page-header-breadcrumb">
					<div class="breadcrumb-nav breadcrumb-nav-composed">
						<ul class="nav-links">
							<li class="nav-link" @click="goHome">
								<a >Home</a>
							</li>
							<li class="nav-link">
								<span>China</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="page-header  no-bg-img page-title-large headline-module__wrapper headline-module__headline"
				style="">
				<div class="page-wrapper">
					<div class="content">
						<h1 class="page-title">China</h1>
					</div>
				</div>
			</div>
			<div class="page-wrapper headline-module__page-header ">
				<div class="embed-card">
					<div class="embed-card__embed embed-card__china-bg">
						<img class="headline-module__image" src="../../assets/test/china.webp" alt="Chinese lanterns">
					</div>
					<div class="embed-card__content">
						<div class="embed-card__tag">
							Insight | Legal Alert
						</div>
						<h4 class="embed-card__title">
							New Rules to Facilitate and Standardize Cross-Border Transfer of Data Outside China
						</h4>
						<div class="embed-card__copy">
							On March 22, 2024, the Cyberspace Administration of China issued the long waited Provisions
							on Facilitating and Standardizing Cross-Border Data Flow, which took effect from the same
							date.
						</div>
						<a class="embed-card__link link--outbound" >
							Read More
						</a>
					</div>
				</div>
			</div>
			<div class="orderable-modules">
				<div class="global-module-page-wrapper">
					<div class="overview-module global-module">
						<div class="global-module-wrapper">

							<div data-module-id="2e093092-10ea-495d-936c-0d9312c753fd" class="js-overview-expand">
								<div class="section-header-wrapper">
									<h2 class="section-header">Overview</h2>
								</div>

								<div class="overview-intro description rte no-expand-text">
									<p style="text-align: left;">Our China lawyers advise clients on some of the most
										significant deals in the Chinese and international markets. We advised Metro AG
										on the sale of the majority stake in Metro China to Wumei, and CITIC Metal on
										its acquisition of an additional 10% stake in Ivanhoe Mines, as well as the USD
										26 billion merger between CSR and China CNR, the two largest train manufacturers
										in China.
									</p>
									<p>The quality of our work is reflected in the number of leading Chinese companies,
										multinationals and financial institutions that seek our advice, as well as the
										recognition we receive within the legal industry. We were named as International
										Firm of Year by China Law &amp; Practice in 2020. We have also received the
										award of Law Firm of the Year (International) for the sixth consecutive year
										from 2016 to 2021 from the China Business Law Journal. Our corporate/M&amp;A,
										banking and finance, capital markets, dispute resolution, employment, tax,
										intellectual property and compliance practices have also won major awards.</p>
									<p>With nearly 300 qualified lawyers in China, we provide domestic and cross-border
										advice on mergers and acquisitions, capital markets, banking and finance,
										employment, real estate, IT &amp; communications, intellectual property, dispute
										resolution and tax — all top-ranked practice groups by legal publications
										including Chambers Asia Pacific, the Legal 500 Asia Pacific, Asia Legal
										Business, China Law and Practice, and IFLR 1000. No matter the legal or business
										challenge, we work with colleagues across borders and practice areas to help
										clients achieve their strategic goals.</p>
									<h4>Baker McKenzie FenXun (FTZ) Joint Operation</h4>
									<p>We are the first international firm to be granted a joint operation license in
										the Shanghai Free Trade Zone. We were established in 2015 with PRC law firm
										FenXun Partners. This historic move enables us to provide Chinese and
										multinationals operating in China with aligned international and PRC legal
										services on corporate finance, M&amp;A, reorganizations, FDI into China,
										antitrust, employment, intellectual property, and securities offerings, listings
										and IPOs.</p>
									<p>Under Chinese regulations, our relationship with FenXun Partners is a joint
										operation, not a merger. Baker McKenzie and FenXun Partners remain structurally
										separate and function as independent law firms.</p>
									<p>The Joint Operation Office received the Joint Operation Office Award <span
											style="background-color: #ffffff; color: #4d5156;">–&nbsp;</span>Law Firm of
										the Year from Chambers Asia Pacific, Chambers China Awards, 2020. This is a
										great recognition from the market.</p>
									<p><span><a rel="noopener noreferrer" href="javascript:;" @click="toPage('/')">&gt;&gt; Find out more information on our capabilities
												and our team in China</a></span></p>
									<br>
									<p style="text-align: center;">
										<img src="../../assets/test/001.webp" alt="China offices anniversary logos" width="599" height="180"></p>
								</div>

							</div>
						</div>
					</div>
				</div>
				<div class="office-grid global-module global-module global-module-page-wrapper">
					<div class="global-module-wrapper">
						<h2 class="module-header">Offices</h2>
						<div class="office-grid-tiles">
							<div class="office-tile no-right-margin">
								<h3 class="office-title">Beijing</h3>
								<address>Suite 3401, China World Office 2,<br>China World Trade Centre,<br>1
									Jianguomenwai Dajie,<br>Beijing 100004</address>
								<div class="office-contact">
									<span class="phone" data-phonenumber="+86 10 6535 3800">Tel: +86 10 6535 3800</span>
									<span class="fax" data-phonenumber="+86 10 6505 2309">Fax: +86 10 6505 2309</span>
								</div>
								<a class="office-link">View Beijing Office </a>

							</div>
							<div class="office-tile no-right-margin">
								<h3 class="office-title">Hong Kong</h3>
								<address>14th Floor, One Taikoo Place<br>979 King’s Road, Quarry Bay<br>Hong Kong
									SAR<br><br></address>
								<div class="office-contact">
									<span class="phone" data-phonenumber="+852 2846 1888">Tel: +852 2846 1888</span>
									<span class="fax" data-phonenumber="+852 2845 0476">Fax: +852 2845 0476</span>
								</div>



								<a class="office-link">View Hong Kong Office </a>

							</div>
							<div class="office-tile no-right-margin">
								<h3 class="office-title">Shanghai</h3>
								<address>Unit 1601, Jin Mao Tower,<br>88 Century Avenue, Pudong,<br>Shanghai 200121
								</address>
								<div class="office-contact">
									<span class="phone" data-phonenumber="+86 21 6105 8558">Tel: +86 21 6105 8558</span>
									<span class="fax" data-phonenumber="+86 21 5047 0020">Fax: +86 21 5047 0020</span>
								</div>
								<a class="office-link">View Shanghai Office </a>
							</div>

						</div>
					</div>
				</div>
				<div class="global-module-page-wrapper">
					<div class="tabs-module global-module ">
						<div class="global-module-wrapper">
							<div class="tabs-panel-module js-tabs-panel-module">
								<div class="tabs-panel-nav js-tabs-panel-nav">
									<button class="tabs-panel-nav-toggle js-tabs-panel-nav-trigger">Our
										Expertise</button>
									<ul class="tabs-panel-nav-list js-tabs-panel-nav-list">
										<li class="tabs-panel-nav-item">
											<button data-href="#ourexpertise" aria-controls="ourexpertise"
												class="tabs-panel-nav-link js-tabs-panel-nav-link" :class="tabIndex == 1 ? 'is-selected' : ''"
												role="button"  @click="selectTab(1)">Our Expertise</button>
										</li>
										<li class="tabs-panel-nav-item">
											<button data-href="#careers" aria-controls="careers"
												class="tabs-panel-nav-link js-tabs-panel-nav-link" :class="tabIndex == 2 ? 'is-selected' : ''"
												role="button" @click="selectTab(2)">Careers</button>
										</li>
										<li class="tabs-panel-nav-item">
											<button data-href="#insight" aria-controls="insight"
												class="tabs-panel-nav-link js-tabs-panel-nav-link" :class="tabIndex == 3 ? 'is-selected' : ''"
												role="button" @click="selectTab(3)">Insight</button>
										</li>
										<li class="tabs-panel-nav-item">
											<button data-href="#news" aria-controls="news"
												class="tabs-panel-nav-link js-tabs-panel-nav-link" :class="tabIndex == 4 ? 'is-selected' : ''"
												role="button" @click="selectTab(4)">News</button>
										</li>
									</ul>
								</div>
								<div class="tabs-panels-all js-tabs-panel-all" style="">
									<a class="tab-anchor" id="ourexpertise" target="_blank"></a>
									<div class="tabs-panel js-tabs-panel" :class="tabIndex == 1 ? 'is-active-panel' : ''">

										<div data-module-id="e6884cf0-b65c-4d6d-ae62-d5ebd5151750"
											class="js-overview-expand">

											<div class="overview-intro description rte ">
												Our lawyers in China have sophisticated technical skills, speak multiple
												languages and understand the needs and perspectives of both Chinese and
												global companies. These qualities enable our China offices to support
												domestic and international transactions with ease and help clients
												achieve their objectives.
											</div>

											<div :style="{display:ExpertiseSeeMore}" aria-hidden="true"
												data-overview-label-more="See More" data-overview-label-less="See Less"
												class="overview-full description js-overview-full rte">
												<p>Our M&amp;A team of 100 lawyers across our Beijing, Shanghai and Hong
													Kong offices has a long history of structuring and executing
													corporate and M&amp;A investments in Mainland China, including
													helping strategic and financial investors survey their options,
													customize their business strategies and navigate the government
													approval process. We also advise Chinese companies investing abroad.
												</p>
												<p>Our capital markets practice, which covers Hong Kong, China and Asia
													Pacific, focuses on initial public offerings, compliance, corporate
													restructurings and public M&amp;A. We advise clients in industries
													including oil and gas, real estate, TMT, life sciences and financial
													services.</p>
												<p>Our employment practice covers all aspects of labor and employment
													law, including tax, immigration, discrimination, pensions, privacy,
													labor union and employee benefits. Our lawyers not only advise on
													local employment issues but also complex cross-border matters
													involving multiple jurisdictions.</p>
												<p>Our intellectual property practice represents the owners of many of
													the world’s best-known brands, helping them manage their IP
													portfolios and comply with product regulations. We also lobby the
													Chinese government on IP matters through our involvement in the
													International Trademark Association, the International
													Anti-Counterfeiting Coalition and the Quality Brands Protection
													Committee.</p>
												<p>In China, our real estate group is ranked a top-tier practice by
													numerous legal directories. From project development to financing
													and acquisition, we advise on commercial, residential, industrial,
													mixed use, infrastructure and other emerging assets. We also advise
													clients on listed REITs and unlisted private equity <span
														style="background-color: #ffffff; color: #4d5156;">–&nbsp;</span>style
													real estate funds.&nbsp;&nbsp;</p>
												<p>Our award-winning tax practice advises clients across the Greater
													China region and beyond on tax planning, business and corporate
													structuring, M&amp;A, tax controversy, litigation and transfer
													pricing, as well as personal tax matters.
												</p>
												<p>We also provide local and global advice in the following areas:</p>
												<ul>
													<li>Aircraft Finance </li>
													<li>Antitrust &amp; Competition </li>
													<li>Banking &amp; Finance </li>
													<li>Compliance &amp; Investigations </li>
													<li>Dispute Resolution </li>
													<li>Energy, Mining &amp; Infrastructure </li>
													<li>Financial Services &amp; Regulation </li>
													<li>Healthcare </li>
													<li>Insurance&nbsp;</li>
													<li>IT &amp; Communications </li>
													<li>Private Equity </li>
													<li>International Commercial &amp; Trade
													</li>
												</ul>
											</div>
											<div class="overview-button-trigger">
												<button
													class="button-red button-medium button-expand js-overview-trigger"
													aria-expanded="false" aria-controls="readmoreText" @click="openExpertiseMore">See More</button>
											</div>
										</div>
									</div>
									<a class="tab-anchor" id="careers" target="_blank"></a>
									<div class="tabs-panel js-tabs-panel" :class="tabIndex == 2 ? 'is-active-panel' : ''">

										<div data-module-id="87e9089f-84f4-4ed5-864e-fd402e483a23"
											class="js-overview-expand">

											<div class="overview-intro description rte no-expand-text">
												<h4>Local Programs</h4>
												<p>Our PRC Global Internship offers up to four local PRC scholarship
													winners who have interned in our Beijing and Shanghai offices the
													opportunity to participate in one-month internships in one of our
													global offices. Interns receive USD 2,500 stipends, paid travel and
													accommodations and permanent job offers in our Beijing or Shanghai
													office upon completing the program. Participating offices include
													Sydney, Tokyo, Singapore, Kuala Lumpur, Jakarta, Sao Paulo, London,
													Paris, Istanbul, New York, Washington, DC, Chicago, and San
													Francisco/Palo Alto.</p>
												<h4>Regional Programs</h4>
												<p>We work with our colleagues across Asia Pacific to provide programs
													that focus on career development and technical skills. These include
													the Asia Pacific Associates program, the M&amp;A Rising Stars
													program, the Local Partner Development Center and the Principal
													Leadership Program.</p>
												<h4>Global Programs</h4>
												<p>Our Associate Training Program offers associates the chance to gain
													broader legal and commercial experience through secondments to
													offices in other regions. </p>
											</div>

										</div>
									</div>
									<a class="tab-anchor" id="insight" target="_blank"></a>
									<div data-panel="" class="tabs-panel js-tabs-panel" :class="tabIndex == 3 ? 'is-active-panel' : ''">
										<div class="description intro">
											<p style="text-align: center;">Get up-to-date information on the current
												legal and regulatory matters impacting your business. Search by country,
												industry and area of legal practice.</p>
											<p style="text-align: center;"><a><button class="button-red">Visit
														InsightPlus</button></a></p>
											<br>
										</div>
										<div class="articles-related-module featured-insights js-articles-related-module">
											<div class="featured-insights__collection js-article-list"
												data-child-selector="4">
												<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
													<a class="promo-content-link">
														<div class="container-table">
															<div class="pcm-standard-background-image" :style="{background: 'url('+ topicBgList[0] +') no-repeat',backgroundSize:'cover'}"></div>
															<div class="container-row">
																<div class="content">
																	<div class="content-type-label">Insight | Thought
																		Leadership</div>
																	<div class="content-headline">Unlocking and
																		Accelerating Growth: Healthcare and Life
																		Sciences in Asia Pacific</div>
																	<div class="content-summary">Healthcare and life
																		sciences breakthroughs offer opportunities to
																		meet patient needs and create value, but rising
																		costs and market uncertainty also apply
																		significant pressure to operations.</div>
																</div>
															</div>
														</div>
													</a>
												</div>
												<div class="featured-insights__tile promo-content-tile ">
													<a class="promo-content-link">
														<div class="container-table">
															<div class="container-row">
																<div class="content">
																	<div class="content-type-label">Insight | Legal
																		Update</div>
																	<div class="content-headline">How AI is Transforming
																		Asia's Dealmaking Landscape </div>
																	<div class="content-summary">AI is transforming
																		Asia's M&amp;A landscape. Robert Wright and
																		Theodore Heng of our M&amp;A and Private Equity
																		Practice Groups highlight the key trends in an
																		interview with IFLR.</div>
																</div>
															</div>
														</div>
													</a>
												</div>
												<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
													<a class="promo-content-link">
														<div class="container-table">
															<div class="pcm-standard-background-image" :style="{background: 'url('+ topicBgList[1] +') no-repeat',backgroundSize:'cover'}">
															</div>
															<div class="container-row">
																<div class="content">
																	<div class="content-type-label">Insight | Handbook
																	</div>
																	<div class="content-headline">Asia Pacific Antitrust
																		and Competition Handbook</div>
																	<div class="content-summary">A practical resource to
																		support in-house teams in identifying potential
																		antitrust risks in an increasingly complex
																		regulatory environment.</div>
																</div>
															</div>
														</div>
													</a>
												</div>
												<template v-if="moreInsight">
													<div class="featured-insights__tile promo-content-tile ">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">Insight | Thought
																			Leadership</div>
																		<div class="content-headline">Navigating
																			cross-border data transfers in the Greater Bay
																			Area</div>
																		<div class="content-summary">In an interview with
																			Asian Private Banker, Dominic Edmondson
																			discusses how financial institutions should
																			assess which framework to use when transferring
																			personal data outside of mainland China.&nbsp;
																		</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="pcm-standard-background-image" :style="{background: 'url('+ topicBgList[3] +') no-repeat',backgroundSize:'cover'}">
																</div>
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">Insight | Handbook
																		</div>
																		<div class="content-headline">Asia Pacific Guide to
																			Lending and Taking Security</div>
																		<div class="content-summary">This guide covers
																			regulatory banking requirements for lending in
																			13 jurisdictions, and contains relevant
																			information when considering whether to lend and
																			what happens if things go wrong.</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													<div class="featured-insights__tile promo-content-tile ">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">Insight | Podcast
																		</div>
																		<div class="content-headline">Asia Pacific
																			Competition Podcasts</div>
																		<div class="content-summary">We delve into the
																			antitrust issues that are currently top-of-mind
																			in the region.</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													<div class="promo-content-tile featured-insights__tile view-all-placeholder">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<span class="button-red" @click="toPage('/insight')">View All Insight</span>
																</div>
															</div>
														</a>
													</div>
												</template>
											</div>
											<button data-scroll-up="true" data-label-expand="See More Insight"
												data-label-collapse="See Less Insight"
												class="button-red button-expand js-button-expand" @click="showMoreInsight">See More
												Insight</button>
										</div>
									</div>
									<a class="tab-anchor" id="news" target="_blank"></a>
									<div data-panel="" class="tabs-panel js-tabs-panel" :class="tabIndex == 4 ? 'is-active-panel' : ''">
										<div class="articles-related-module featured-insights js-articles-related-module">
											<div class="featured-insights__collection js-article-list"
												data-child-selector="4">
												<div class="featured-insights__tile promo-content-tile ">
													<a class="promo-content-link">
														<div class="container-table">
															<div class="container-row">
																<div class="content">
																	<div class="content-type-label">News | Deal
																		Announcement</div>
																	<div class="content-headline">Baker McKenzie advises
																		Gaw Capital on its partnership with GDS to build
																		a 40-megawatt data center campus in Japan</div>
																	<div class="content-summary">The 40-megawatt
																		carrier-neutral data center campus in Fuchu City
																		will be the largest in the city in terms of IT
																		load.</div>
																</div>
															</div>
														</div>
													</a>
												</div>
												<div class="featured-insights__tile promo-content-tile ">
													<a class="promo-content-link">
														<div class="container-table">
															<div class="container-row">
																<div class="content">
																	<div class="content-type-label">News | Firm News
																	</div>
																	<div class="content-headline">Healthcare and Life
																		Sciences in Asia Pacific: 2024 sets to see
																		rising investment and innovation</div>
																	<div class="content-summary">According to Baker
																		McKenzie's new digital report “Unlocking and
																		Accelerating Growth: Healthcare and Life
																		Sciences in Asia Pacific.”&nbsp;</div>
																</div>
															</div>
														</div>
													</a>
												</div>


												<div class="featured-insights__tile promo-content-tile ">
													<a class="promo-content-link">
														<div class="container-table">
															<div class="container-row">
																<div class="content">
																	<div class="content-type-label">News | Deal
																		Announcement</div>
																	<div class="content-headline">Baker McKenzie
																		Collaborates with Chinese Arbitration
																		Association (CAA), Taipei to Enhance Taiwan's
																		International Arbitration Standards</div>
																	<div class="content-summary">Members of the Firm's
																		Dispute Resolution team shared their extensive
																		knowledge with the local legal community.</div>
																</div>
															</div>
														</div>
													</a>
												</div>

												<template v-if="moreNews">
													<div class="featured-insights__tile promo-content-tile ">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">News | Deal
																			Announcement</div>
																		<div class="content-headline">Baker McKenzie advises
																			CapitaLand Investment on the first
																			sustainability-linked panda bond issued by a
																			Singapore company</div>
																		<div class="content-summary">This is also the first
																			panda bond issued by an enterprise in ASEAN
																			after the Regional Comprehensive Economic
																			Partnership.</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													<div class="featured-insights__tile promo-content-tile ">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">News | Firm News
																		</div>
																		<div class="content-headline">Baker McKenzie Partner
																			Christina Lee appointed as member of Takeovers
																			and Mergers Panel and Takeovers Appeal Committee
																			for Hong Kong Securities and Futures Commission
																		</div>
																		<div class="content-summary">Christina is chair of
																			the Asia Pacific Capital Markets Practice.</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													<div class="featured-insights__tile promo-content-tile ">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<div class="content">
																		<div class="content-type-label">News | Deal
																			Announcement</div>
																		<div class="content-headline">Baker McKenzie advises
																			Cambium Grove Capital in connection with the
																			acquisition of a commercial property in Tokyo,
																			Japan</div>
																		<div class="content-summary">The transaction adds to
																			the list of cross-border deals on which the Firm
																			previously advised CGC across various asset
																			classes.</div>
																	</div>
																</div>
															</div>
														</a>
													</div>
													<div class="promo-content-tile featured-insights__tile view-all-placeholder">
														<a class="promo-content-link">
															<div class="container-table">
																<div class="container-row">
																	<span class="button-red" @click="toPage('/newsroom')">View All News</span>
																</div>
															</div>
														</a>
													</div>
												</template>
											</div>
											<button data-scroll-up="true" data-label-expand="See More News"
												data-label-collapse="See Less News"
												class="button-red button-expand js-button-expand" @click="showMoreNews">See More News</button>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
				<div class="global-module-page-wrapper">
					<div class="contact-module js-contact-module contact-module-default-bg contact-module-center global-module">
						<div class="global-module-wrapper">
							<div class="section-header-wrapper">
								<h2 class="section-header">Key Contacts</h2>
							</div>
							<ul class="main-contacts secondary-main-contacts">
								<li class="contact-information" v-for="(item,index) in ContactsList">
									<h4 class="contact-title">{{item.title}}</h4>

									<a href="javascript:;" @click="toPage('/people')" class="professional-tile">
										<div class="content">
											<figure class="profile-image">
												<img :src="item.img">
											</figure>
											<div class="profile">
												<h3 class="name">{{item.name}}</h3>

												<div class="title">Partner</div>

												<ul class="locations">
													<li class="location">{{item.location}}</li>
												</ul>

												<div class="bottom">
													<div class="contact">
														<span class="phone">{{item.phone}}</span>
														<span class="contact-link-url email"><span class="iconfont icon-email"></span>Email</span>
													</div>

												</div>
											</div>
										</div>
									</a>
								</li>
							</ul>
							<button id="view-more" class="button-red contact-module-basic-button" @click="toPage('/people')">View All Contacts in China</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footer class="global-footer">
			<div class="communication-footer hide-print">
				<ul class="social-links">
					<li class="social-link"><a class="bm bm-linkedin" aria-label="Baker McKenzie LinkedIn "></a></li>
					<li class="social-link"><a class="bm bm-twitter" aria-label="Baker McKenzie Twitter"></a></li>
					<li class="social-link"><a class="bm bm-facebook" aria-label="Baker McKenzie Facebook "></a></li>
					<li class="social-link"><a class="bm bm-youtube" aria-label="Baker McKenzie YouTube"></a></li>
					<li class="social-link"><a class="bm bm-we-chat" aria-label="Baker McKenzie WeChat"></a></li>
					<li class="social-link"><a class="bm bm-rss" aria-label="Baker McKenzie RSS"></a></li>
				</ul>
			</div>
			<div class="footer-nav hide-print">
				<ul class="utility-links">
					<li class="utility-link"><a>Disclaimers</a></li>
					<li class="utility-link"><a>Privacy &amp; Cookies Statement</a></li>
					<li class="utility-link"><a title="Manage Choices">Cookie Preferences</a></li>
					<li class="utility-link"><a>CCPA Privacy Disclosures</a></li>
					<li class="utility-link"><a>Contact Us</a></li>
					<li class="utility-link"><a>Media Contacts</a></li>
					<li class="utility-link"><a>Blogs</a></li>
					<li class="utility-link"><a>BM Online</a></li>
				</ul>
		
			</div>
			<div class="copyright">
				<p><span>Attorney Advertising | © 2024 Baker McKenzie</span></p>
			</div>
		</footer>
	</div>
</template>

<script>
	import Header from '../../components/header.vue'
	export default {
		components: {
			Header
		},
		data() {
			return {
				headerMini: false,
				thresholdHeight: 100,
				ExpertiseSeeMore:'none',
				tabIndex:1,
				topicBgList:[
					require('../../assets/test/02.jpeg'),
					require('../../assets/test/65.webp'),
					require('../../assets/test/55.webp'),
					require('../../assets/test/57.webp'),
				],
				moreInsight:false,
				moreNews:false,
				ContactsList:[
					{
						name:'Lawrence K.H. Lee, BBS, JP',
						img:require('../../assets/test/111.webp'),
						title:'Chairman',
						location:'Hong Kong',
						phone:'+ 852 2846 1980',
						email:'w.com'
					},
					{
						name:'Steven R. Sieker',
						img:require('../../assets/test/112.webp'),
						title:'Managing Partner',
						location:'Hong Kong',
						phone:'+ 852 2846 1048',
						email:'w.com'
					}
				],
			}
		},
		mounted() {
			window.addEventListener('scroll', this.checkScrollPosition);
		},
		beforeDestroy() {
			// 在组件销毁前移除滚动监听
			window.removeEventListener('scroll', this.checkScrollPosition);
		},
		methods: {
			checkScrollPosition() {
				this.headerMini = window.scrollY >= this.thresholdHeight;
			},
			goHome() {
				this.$router.replace('/');
			},
			toPage(path) {
				this.$router.replace(path);
			},
			openExpertiseMore(){
				if (this.ExpertiseSeeMore == 'none') {
					this.ExpertiseSeeMore = 'block'
				} else {
					this.ExpertiseSeeMore = 'none'
				}
			},
			selectTab(e){
				this.tabIndex = e
			},
			showMoreInsight(){
				this.moreInsight = !this.moreInsight
			},
			showMoreNews(){
				this.moreNews = !this.moreNews
			},
		}
	}
</script>

<style src="@/assets/main.css" scoped></style>
<style lang='scss' scoped>
	.body-container {
		/* min-width: 1280px; */
		width: 100%;
		min-height: 100vh;
		overflow: hidden;
		position: relative;
		background-color: #fff;
	}

	.main {
		padding-top: 82px;
	}
	.embed-card__china-bg {
		background-image:url('../../assets/test/china.webp')
	}
	.tabs-module .promo-content-tile .container-row{
	    height: auto;
	}
	.articles-related-module.featured-insights .featured-insights__collection[data-child-selector="4"] .featured-insights__tile[data-v-97b80192]:nth-of-type(n+4) {
	    display: block;
	}
	.icon-email {
		margin-right: 5px;
	}
	/* mobile screen */
	@media (max-width: 800px) {
		.global-module.global-module-page-wrapper .global-module-wrapper {
			width: 87% !important;
		}
		.tabs-panel-nav-toggle {
			width: 89% !important;
		}
		.global-footer .footer-nav .utility-links .utility-link, .global-footer-social .footer-nav .utility-links .utility-link {
		    width: 38%;
		    padding-bottom: 1em;
		    padding-right: 0;
		    padding-left: 2.5em;
		    min-height: 40px;
		}
		.main {
			padding-top: 63px;
		}
	}
</style>
